import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  FORGOT_PASSWORD_PREFIX,
  REGISTER_PREFIX,
} from '../../constants/router';
import ButtonCommon from '../common/ButtonCommon';

const FormLogIn = ({
  noticeDisplay,
  renderFormInputValidations,
  handleSubmit,
  onForgotPassword,
}) => {
  const { t } = useLang();
  const navigate = useNavigate();

  const handleForgotPassword = () => {
    onForgotPassword();
    navigate(FORGOT_PASSWORD_PREFIX);
  };

  return (
    <FormLogInStyled $noticeDisplay={noticeDisplay}>
      {renderFormInputValidations()}
      <ForgotPasswordSubmit>
        {onForgotPassword ? (
          <ForgotPasswordButton onClick={handleForgotPassword}>
            {t('button_forgot_password')}
          </ForgotPasswordButton>
        ) : (
          <LinkForgotPasswordStyled to={FORGOT_PASSWORD_PREFIX}>
            {t('button_forgot_password')}
          </LinkForgotPasswordStyled>
        )}
        <ButtonCommon
          value={t('button_login')}
          styles={{
            margin: '0px',
            width: '200px',
          }}
          onClick={handleSubmit}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
          isUseKeyDown={true}
          isUseKeyDownException={true}
        />
      </ForgotPasswordSubmit>
      <Register>
        {t('login_text_no_account')}{' '}
        <LinkRegisterStyled to={REGISTER_PREFIX}>
          {t('button_register_now')}
        </LinkRegisterStyled>
      </Register>
    </FormLogInStyled>
  );
};

const FormLogInStyled = styled(Form)`
  position: relative;
  width: 100%;
  height: ${(props) =>
    props.$noticeDisplay ? 'calc(100% - 205px)' : 'calc(100% - 96px)'};
`;

const LinkForgotPasswordStyled = styled(Link)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-decoration: none;

  color: #002ff1;
  display: block;

  &:hover {
    color: var(--ds-c-blue-hover) !important;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const LinkRegisterStyled = styled(Link)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-decoration: none;
  color: var(--bg-primary);
  text-transform: uppercase;

  &:hover,
  &:active {
    color: var(--bg-primary-hover);
  }
`;

const ForgotPasswordSubmit = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Register = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  position: absolute;
  bottom: 0px;
  color: var(--ds-c-grey-dark);
  margin-bottom: 0px;
`;

const ForgotPasswordButton = styled.button`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  color: #002ff1;
  display: block;

  &:hover {
    color: var(--ds-c-blue-hover) !important;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default FormLogIn;
